export const generarMensajeWhatsApp = ({ nombre, apellido, direccion, telefono, metodoPago, productos }) => {
  const total = productos.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const productosTexto = productos
    .map(
      (item) =>
        `• ${item.name} x${item.quantity} - $${(item.price * item.quantity).toFixed(2)}`
    )
    .join("\n");

  const mensaje = 
    `📄 *Nueva Orden de Pedido*\n\n` +
    `👤 *Cliente*: ${nombre}\n` +
    `📍 *Dirección*: ${direccion}\n` +
    `☎️ *Teléfono*: ${telefono}\n\n` +
    `📦 *Productos:*\n${productosTexto}\n\n` +
    `💵 *Total*: $${total.toFixed(2)}\n` +
    `💳 *Pago con*: ${metodoPago}`;

  return mensaje;
};
